import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1493.49214,0.0244900448 L0.94091614,1492.58261 L427.385403,1919.02051 L608.272192,1738.13472 L608.39113,1738.25466 L683.776866,1662.87392 L683.657928,1662.75398 L759.043665,1587.36325 L759.161603,1587.48319 L834.54734,1512.10245 L834.429401,1511.98251 L909.814138,1436.59178 L909.933077,1436.71171 L985.317814,1361.33097 L985.199875,1361.21104 L1060.58761,1285.8303 L1060.70755,1285.94024 L1136.08829,1210.5595 L1135.96835,1210.43956 L1211.35908,1135.05882 L1211.47902,1135.16877 L1286.85976,1059.78803 L1286.73982,1059.66809 L1362.13056,984.283352 L1362.25049,984.40229 L1437.63123,909.016554 L1437.5113,908.897616 L1512.90203,833.512879 L1513.01197,833.630817 L1588.40271,758.24608 L1588.28277,758.127142 L1663.6735,682.741406 L1663.78345,682.860344 L1739.17418,607.474607 L1739.05424,607.356668 L1919.94003,426.468881 L1493.49214,0.0244900448 Z M1663.6735,531.970932 L1769.16856,426.468881 L1493.49214,150.795461 L151.711983,1492.58261 L427.385403,1768.25903 L532.887454,1662.75398 L432.742613,1562.60614 L508.12835,1487.2254 L608.272192,1587.36325 L683.657928,1511.98251 L583.514086,1411.83467 L658.898824,1336.45393 L759.043665,1436.59178 L834.428402,1361.21104 L658.898824,1185.68246 L734.28456,1110.29172 L909.814138,1285.8203 L985.199875,1210.43956 L885.056033,1110.29172 L960.44077,1034.91098 L1060.58761,1135.05882 L1135.96835,1059.66809 L1035.8305,959.525247 L1111.21124,884.139511 L1211.35908,984.283352 L1286.73982,908.897616 L1111.21124,733.368037 L1186.60198,657.9833 L1362.13056,833.512879 L1437.5113,758.127142 L1337.36346,657.9833 L1412.75419,582.597564 L1512.90203,682.741406 L1588.28277,607.355669 L1488.13493,507.211827 L1563.52566,431.826091 L1663.6735,531.970932 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconRulerLine = /*#__PURE__*/function (_Component) {
  _inherits(IconRulerLine, _Component);

  var _super = _createSuper(IconRulerLine);

  function IconRulerLine() {
    _classCallCheck(this, IconRulerLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconRulerLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconRuler",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconRulerLine.displayName = "IconRulerLine";
  return IconRulerLine;
}(Component);

IconRulerLine.glyphName = 'ruler';
IconRulerLine.variant = 'Line';
IconRulerLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconRulerLine;
export { IconRulerLine };